/// <amd-module name="TFS/Admin/Views/GitHubConnection/redux/GitHubConnectionSelectors" />
import { IGitHubConnectionAwareState } from "TFS/Admin/Views/GitHubConnection/Contracts";

export function getCanEdit(state: IGitHubConnectionAwareState): boolean | undefined {
    if (!state || !state.gitHubConnectionState.canEdit) {
        return undefined;
    }

    return state.gitHubConnectionState.canEdit;
}

export function getCollectionId(state: IGitHubConnectionAwareState): string | undefined {
    if (!state || !state.gitHubConnectionState.collectionId) {
        return undefined;
    }

    return state.gitHubConnectionState.collectionId;
}

export function getToggleState(state: IGitHubConnectionAwareState): boolean | undefined {
    if (!state || !state.gitHubConnectionState.collectionMarkToggle) {
        return undefined;
    }

    return state.gitHubConnectionState.collectionMarkToggle;
}

export function getLoading(state: IGitHubConnectionAwareState): boolean | undefined {
    if (!state || state.gitHubConnectionState.loading === undefined) {
        return true;
    }

    return state.gitHubConnectionState.loading;
}

export function getIsAadConnected(state: IGitHubConnectionAwareState): boolean | undefined {
    if (!state || !state.gitHubConnectionState.isAadConnected) {
        return undefined;
    }

    return state.gitHubConnectionState.isAadConnected;
}

export function getGitHubConnectUrl(state: IGitHubConnectionAwareState): string | undefined {
    if (!state || !state.gitHubConnectionState.gitHubConnectUrl) {
        return undefined;
    }

    return state.gitHubConnectionState.gitHubConnectUrl;
}

export function getIsGitHubConnected(state: IGitHubConnectionAwareState): boolean | undefined {
    if (!state || !state.gitHubConnectionState.isGitHubConnected) {
        return undefined;
    }

    return state.gitHubConnectionState.isGitHubConnected;
}

export function getIsToggleEnabled(state: IGitHubConnectionAwareState): boolean | undefined {
    if (!state || !state.gitHubConnectionState.isToggleEnabled) {
        return undefined;
    }

    return state.gitHubConnectionState.isToggleEnabled;
}
export function getOrgName(state: IGitHubConnectionAwareState): string {
    if (!state || !state.gitHubConnectionState.orgName) {
        return "";
    }

    return state.gitHubConnectionState.orgName;
}
